import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'CeviriPro';
const BASE_URL = 'https://ceviripro.com.tr';
const OG_IMAGE = `${BASE_URL}/og-image.png`;
const TWITTER_HANDLE = '@ceviripro';

/**
 * Reusable per-page SEO component.
 * Usage: <SEO title="Sayfa Başlığı" description="Açıklama..." canonical="/path" schema={jsonLdObject} />
 */
function SEO({ title, description, canonical = '/', schema }) {
    const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} — PDF, DOCX, EPUB Belge Çeviri | 100+ Dil`;
    const canonicalUrl = `${BASE_URL}${canonical}`;
    const desc = description ||
        "PDF, Word ve EPUB dosyalarınızı 100'den fazla dile saniyeler içinde çevirin. Yapay zeka destekli, OCR teknolojili, güvenli belge çeviri platformu.";

    return (
        <Helmet>
            {/* ── Primary ── */}
            <title>{fullTitle}</title>
            <meta name="description" content={desc} />
            <link rel="canonical" href={canonicalUrl} />

            {/* ── hreflang ── */}
            <link rel="alternate" hreflang="tr" href={canonicalUrl} />
            <link rel="alternate" hreflang="x-default" href={canonicalUrl} />

            {/* ── Open Graph ── */}
            <meta property="og:type" content="website" />
            <meta property="og:site_name" content={SITE_NAME} />
            <meta property="og:locale" content="tr_TR" />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={desc} />
            <meta property="og:url" content={canonicalUrl} />
            <meta property="og:image" content={OG_IMAGE} />
            <meta property="og:image:width" content="1200" />
            <meta property="og:image:height" content="630" />
            <meta property="og:image:alt" content={`${SITE_NAME} — Belge Çeviri Platformu`} />

            {/* ── Twitter/X Card ── */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:site" content={TWITTER_HANDLE} />
            <meta name="twitter:creator" content={TWITTER_HANDLE} />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={desc} />
            <meta name="twitter:image" content={OG_IMAGE} />

            {/* ── Schema JSON-LD ── */}
            {schema && (
                <script type="application/ld+json">
                    {JSON.stringify(schema)}
                </script>
            )}
        </Helmet>
    );
}

export default SEO;
